<template>
    <div class="page-layout blank contacts-manage">
        <div class="pb-10 pr-3 pl-3">
            <div class="d-flex flex-wrap justify-content-between align-items-center">
                <!-- Breadcrumb Section -->
                <div class="breadcrumbnew">
                    <span><router-link to="/surveyform/listview" class="text-white pl-2 text-line">Survey Forms</router-link></span>
                    <a>Create Survey Forms</a>
                </div>
            </div>
            <div>
                <div class="page-layout carded left-sidebar"
                    style="border: 0px solid rgb(148, 190, 240) !important;border-radius: 0px !important;display:block">
                    <div class="page-content-wrapper" style="padding: 0 0rem;">
                        <div class="page-content custom-scrollbar" style="background-color: transparent !important;">
                            <!-- General Information Section -->
                            <div class="center-content">
                                <div class="preview-elements">
                                    <div class="header-text-heading fs-14 fw-500 text-white">
                                        General Information
                                    </div>
                                    <div class="row px-12">
                                        <div class="col-lg-4 col-md-6 col-sm-12 mt-7">
                                            <span class="fs-14 fw-600 text-secondary">
                                                Title of Survey Form <sup class="fs-14 text-danger">*</sup>
                                            </span>
                                            <div class="d-flex align-items-center">
                                                <input name="survey_title" maxlength="50" v-validate="'required'" class="inputFieldNew mt-3" type="text" v-model="survey.survey_title" placeholder="Enter Title " />
                                            </div>

                                            <span class="invalid-feedback-form text-danger" v-show="errors.has('survey_title')">
                                                {{errors.first('survey_title')}}
                                            </span>
                                        </div>
                                        <div class="col-lg-4 col-md-6 col-sm-12 mt-7">
                                            <div>
                                                <span class="text-secondary whiteSpace vselectLabel fs-14 fw-600"
                                                    style="padding-top:2px">
                                                    Industry Type <sup class="fs-14 pl-02 text-danger">*</sup>
                                                </span>
                                                <div class="d-flex align-items-center">
                                                    <div class="w-100">
                                                        <multiselect
                                                            class="diginew-multiselect surform-ind-type new-align-multi no-default-icon down-arrow mt-3"
                                                            name="industry_type"
                                                            :title="survey.industry_type"
                                                            v-model="survey.industry_type"
                                                            :max-height="200"
                                                            v-validate="'required'"
                                                            :options="industry_type_options"
                                                            @search-change="searchIndustryType"
                                                            @open="searchIndustryType"
                                                            :limit="1"
                                                            :internal-search="true"
                                                            :limit-text="limitIndustryType"
                                                            :multiple="false"
                                                            :allow-empty="true"
                                                            :searchable="true"
                                                            :clear-on-select="false"
                                                            :close-on-select="true"
                                                            :loading="industry_dropdown_loading"
                                                            :options-limit="3000"
                                                             :show-no-results="true"
                                                             :hide-selected="false"
                                                            placeholder="Select Industry Type">
                                                            <template slot="noOptions">
                                                                <div class="text-secondary text-center fw-600">No
                                                                    Industry Type Found</div>
                                                            </template>
                                                            <template slot="noResult">
                                                                <div class="text-secondary text-center fw-600">No
                                                                    Results Found</div>
                                                            </template>
                                                            <template slot="afterList">
                                                                <div v-observe-visibility="reachedEndOfIndustryType" />
                                                            </template>
                                                        </multiselect>
                                                    </div>
                                                </div>
                                                <span class="invalid-feedback-form text-danger" v-show="errors.has('industry_type')">
                                                    {{errors.first('industry_type')}}
                                                </span>
                                            </div>
                                        </div>
                                        <div class="col-lg-4 col-md-6 col-sm-12 mt-7">
                                            <div>
                                                <span class="text-secondary whiteSpace vselectLabel fs-14 fw-600"
                                                    style="padding-top:2px">
                                                    Survey Type <sup class="fs-14 text-danger">*</sup>
                                                </span>
                                                <div class="d-flex align-items-center">
                                                    <div class="w-100">
                                                        <multiselect
                                                            class="diginew-multiselect new-align-multi no-default-icon down-arrow mt-3"
                                                            name="survey_type" :searchable="true"
                                                            label="value"
                                                            v-validate="'required'"
                                                            v-model="survey.survey_type" :options="survey_type_options"
                                                            @search-change="searchSurveyType"
                                                            :loading="survey_dropdown_loading"
                                                            :max-height="200"
                                                            placeholder="Select Survey Type">
                                                            <!-- <template slot="afterList">
                                                                <div
                                                                    class="add-new-option d-flex align-items-center justify-content-between fw-500 p-2">
                                                                    Add New
                                                                    <i class="icon icon-plus ml-2 text-secondary"></i>
                                                                </div>
                                                            </template> -->
                                                            <template slot="noOptions">
                                                                <div class="text-secondary text-center fw-600">No Survey
                                                                    Type Found</div>
                                                            </template>
                                                            <template slot="noResult">
                                                                <div class="text-secondary text-center fw-600">No
                                                                    Results Found</div>
                                                            </template>
                                                            <template slot="afterList">
                                                                <div v-observe-visibility="reachedEndOfSurveyType" />
                                                            </template>
                                                        </multiselect>
                                                    </div>
                                                </div>
                                                <span class="invalid-feedback-form text-danger" v-show="errors.has('survey_type')">
                                                    {{errors.first('survey_type')}}
                                                </span>
                                            </div>
                                        </div>
                                        <div class="col-lg-4 col-md-6 col-sm-12 mt-7">
                                            <div>
                                                <span class="text-secondary whiteSpace vselectLabel fs-14 fw-600"
                                                    style="padding-top:2px">
                                                    Product
                                                </span>
                                                <div class="d-flex align-items-center">
                                                    <div class="w-100">
                                                        <multiselect
                                                            class="diginew-multiselect new-align-multi no-default-icon down-arrow mt-2"
                                                            placeholder="Select Product"
                                                            label="name" open-direction="bottom"
                                                            v-model="survey.product" @open="resetData('name')"
                                                            :options="products_options" track-by="name"
                                                            :multiple="false" :searchable="true" :internal-search="true"
                                                            :clear-on-select="false" :close-on-select="true" :options-limit="3000"
                                                            :max-height="200" :show-no-results="true" :hide-selected="false"
                                                            :blockKeys="['Delete']" :limit="1" :limit-text="limitProduct" :loading="products_loading" @search-change="searchProuctName"
                                                        >
                                                            <template slot="tag" slot-scope="{ option }">
                                                                <span class="custom__tag">
                                                                <span class="filterSelectedName">{{ option.name }}</span>
                                                                    <!-- <span class="custom__remove pointer" @click="removeProductName(option)">
                                                                        <i class="icon icon-close fs-16"></i>
                                                                    </span> -->
                                                                </span>
                                                            </template>
                                                            <template slot="afterList">
                                                                <div v-observe-visibility="reachedEndOfProductName" />
                                                            </template>
                                                            <template slot="noOptions">
                                                                <div class="text-secondary text-center font-weight-bold" >Product Not Found</div>
                                                            </template>
                                                            <template slot="noResult">
                                                                <div class="text-secondary text-center fw-600">No Results Found</div>
                                                            </template>
                                                        </multiselect>
                                                        <!-- <multiselect
                                                            class="diginew-multiselect new-align-multi no-default-icon down-arrow mt-3"
                                                            name="product" :searchable="true" v-model="survey.product"
                                                            :options="product_options" @search-change="searchProduct"
                                                            :loading="product_dropdown_loading"
                                                            label="name"
                                                            :max-height="200"
                                                            placeholder="Select Product">
                                                            <template slot="noOptions">
                                                                <div class="text-secondary text-center fw-600">No
                                                                    Product Found</div>
                                                            </template>
                                                            <template slot="noResult">
                                                                <div class="text-secondary text-center fw-600">No
                                                                    Results Found</div>
                                                            </template>
                                                            <template slot="afterList">
                                                                <div v-observe-visibility="reachedEndOfProductType" />
                                                            </template>
                                                        </multiselect> -->
                                                    </div>
                                                </div>
                                                <!-- <span class="invalid-feedback-form text-danger" v-show="errors.has('product')">
                                                    {{errors.first('product')}}
                                                </span> -->
                                            </div>
                                        </div>
                                        <div class="col-lg-4 col-md-6 col-sm-12 mt-7">
                                            <div class="row">
                                                <div class="col-lg-8 col-md-8 col-sm-6">
                                                    <span class="text-secondary whiteSpace fs-14 vselectLabel fw-600">
                                                        Start Date <sup class="fs-14 text-danger">*</sup>
                                                    </span>
                                                    <div class="d-flex align-items-center mt-3">
                                                        <date-picker v-model="survey.start_date" name="start_date"
                                                            class="meetinfdatetime mx-left calendar-edit-per mr-1"
                                                            format="MM/DD/YYYY" value-type="format" type="date" lang="en"
                                                            :clearable="false" :editable="false" confirm confirm-text="APPLY">
                                                        </date-picker>
                                                        <i class="icon icon-check-circle" style="color: #ff9a06;"></i>
                                                    </div>
                                                    <span class="invalid-feedback-form text-danger" v-if="is_start_date">
                                                        Start Date is required.
                                                    </span>
                                                </div>
                                                <div class="col-lg-4 col-md-4 col-sm-6 margin-res-575">
                                                    <span class="text-secondary whiteSpace fs-14 vselectLabel fw-600">
                                                      Time <sup class="fs-14 text-danger">*</sup>
                                                    </span>
                                                    <div class="d-flex align-items-center mt-3">
                                                        <date-picker  v-model="survey.start_time" name="start_time" class="meetinfdatetime mx-left calendar-edit-per mr-1 calendar-down-arrow-grey no-down-arrow-autofill" format="hh:mm a" type="time" placeholder="HH:MM" value-type="format" lang="en"  :clearable="false" :editable="false" confirm confirm-text="APPLY"></date-picker>
                                                        <i class="icon icon-check-circle" style="color: #ff9a06;"></i>
                                                    </div>
                                                    <span class="invalid-feedback-form text-danger" v-if="is_start_date">Start Time is required.</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-4 col-md-6 col-sm-12 mt-7">
                                            <div class="row">
                                                <div class="col-lg-8 col-md-8 col-sm-6">
                                                    <span class="text-secondary whiteSpace fs-14 vselectLabel fw-600">
                                                        Closure Date <sup class="fs-14 text-danger">*</sup>
                                                    </span>
                                                    <!-- {{current_date}} -->
                                                    <div class="d-flex align-items-center mt-3">
                                                        <date-picker v-model="survey.closure_date"
                                                        name="closure_date" class="meetinfdatetime mx-left calendar-edit-per mr-1 calendar-edit-per mr-1 "
                                                        format="MM/DD/YYYY" value-type="format" type="date" lang="en"
                                                        :clearable="false"
                                                        :default-value="current_date"
                                                        :not-before="survey.start_date"
                                                        :editable="false" confirm confirm-text="APPLY"></date-picker>
                                                    </div>
                                                    <span class="invalid-feedback-form text-danger" v-if="is_closure_date"> Closure Date is required.</span>
                                                </div>
                                                <div class="col-lg-4 col-md-4 col-sm-6 margin-res-575">
                                                    <span class="text-secondary whiteSpace fs-14 vselectLabel fw-600">Time <sup class="fs-14 text-danger">*</sup></span>
                                                    <div class="d-flex align-items-center mt-3">
                                                        <!-- <date-picker v-model="survey.end_time" :not-before="new Date().setHours(moment(new Date().toUTCString()).format('LT').split(':')[0], moment(new Date().toUTCString()).format('LT').split(':')[1].split(' ')[0], 0)" name="start_time" class="meetinfdatetime mx-left calendar-edit-per mr-1 calendar-down-arrow-grey date-picker-clock-svg-icon" format="hh:mm a" type="time" placeholder="HH:MM" value-type="format"  lang="en"  :clearable="false" :editable="false" confirm confirm-text="APPLY"></date-picker> -->
                                                        <date-picker v-model="survey.end_time" name="start_time" class="meetinfdatetime mx-left calendar-edit-per mr-1 calendar-down-arrow-grey hide-seconds date-picker-clock-svg-icon" format="hh:mm a" type="time" :minute-step="1" placeholder="HH:MM" value-type="format"  lang="en"  :clearable="false" :editable="false" confirm confirm-text="APPLY"></date-picker>
                                                    </div>
                                                    <span class="invalid-feedback-form text-danger" v-if="is_end_time">
                                                        End Time is required.
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row px-12 pb-4">
                                        <div class="col-lg-12 col-md-12 col-sm-12 mt-7">
                                            <span class="text-secondary whiteSpace fs-14 vselectLabel fw-600">
                                                Form Description
                                            </span>
                                            <div class="d-flex align-items-center mt-3">
                                                <textarea placeholder="Add Description"
                                                    v-model="survey.form_description"
                                                    class="survey-textarea"  maxlength="500"
                                                    name="description"
                                                    ></textarea>
                                            </div>
                                            <div class="text-right position-relative">
                                                <span class="input-field-length position-absolute" style="right: 0;">{{ survey.form_description.length }}/500</span>
                                            </div>
                                            <!-- <span class="invalid-feedback-form text-danger" v-show="errors.has('description')">
                                                {{errors.first('description')}}
                                            </span> -->
                                        </div>
                                    </div>
                                    <div class="row px-12">
                                        <div class="col-lg-12 col-md-12 col-sm-12 mt-8">
                                            <div class=" d-flex justify-content-between header-text-heading fs-14 fw-500 text-white px-2 py-3">Create Questionnaire
                                                <span>({{survey.questions.length}})</span>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Email -->
                                    <!-- <div class="row px-8">
                                        <div class="col-lg-4 col-md-6 col-sm-12 mt-5">
                                            <span class="fs-14 fw-600 px-2" style="color: #00448b;">
                                                Email ID *
                                            </span>
                                            <div class="d-flex align-items-center">
                                                <input name="email_id" v-validate="'required'"
                                                    class="inputFieldNew mt-3" type="email" v-model="survey.questions.email"
                                                    placeholder="Enter Email ID" />
                                            </div>
                                            <span class="invalid-feedback-form text-danger"
                                                style="text-transform: none !important;"
                                                v-show="errors.has('email_id')">Email ID is required</span>
                                        </div>
                                    </div> -->
                                    <!-- Question Section -->
                                    <div class="d-flex align-items-center justify-content-center h-100" v-if="ajax_call_in_progress">
                                        <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" style="margin: 0 auto;" />
                                    </div>
                                    <div v-else v-for="(questions_type, questions_type_index) in survey.questions" :key="questions_type_index+'questions_type_index'" class="row px-12">
                                        <div class="col-lg-12 col-md-12 col-sm-12 mt-7">
                                            <div class="p-4" style="border: 1px solid #6c6d6f;">
                                                <div class="d-flex justify-content-between align-items-center">
                                                    <div>
                                                        <span class="fs-16 text-secondary">Question {{questions_type_index+1}}</span>
                                                    </div>
                                                    <div class="d-flex align-items-center">
                                                        <el-dropdown trigger="click">
                                                            <span class="el-dropdown-link">
                                                                <i class="icon icon-right icon-arrow-all pointer"></i>
                                                            </span>
                                                            <el-dropdown-menu slot="dropdown">
                                                                <el-dropdown-item>
                                                                    <span v-if="questions_type_index > 0" class="d-flex align-items-center">
                                                                        <i class="icon icon-arrow-up" style="color: #303031 !important;font-size: 20px !important;"></i>
                                                                        <span @click="moveEntry(questions_type_index, 'move_up')" class="fs-14">Move Above</span>
                                                                    </span>
                                                                </el-dropdown-item>
                                                                <el-dropdown-item>
                                                                    <span class="d-flex align-items-center">
                                                                        <i class="icon icon-arrow-down" style="color: #303031 !important; font-size: 20px !important;"></i>
                                                                        <span class="fs-14" @click="moveEntry(questions_type_index, 'move_down')">Move Down</span>
                                                                    </span>
                                                                </el-dropdown-item>
                                                            </el-dropdown-menu>
                                                        </el-dropdown>
                                                        <div class="ml-2 pointer" @click="addNewEntry(questions_type_index)" style="width: 20px; height: 20px;">
                                                            <img src="/static/images/images-new-theme/icons/awesome-copy.svg" width="20" height="20" />
                                                        </div>
                                                        <div class="ml-2 pointer" @click="editQuestion(questions_type, questions_type_index)">
                                                            <img class="mr-1" src="/static/images/images-new-theme/icons/edit.svg" height="15px;">
                                                        </div>
                                                        <i @click="deleteEntry(questions_type_index)" class="icon icon-right icon-delete pointer"></i>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-lg-12 col-md-12 col-sm-12 mt-3"
                                                        style="place-self:flex-end;">
                                                        <div class="d-flex">
                                                            <span class="fs-14" style="color: #3f3f3f; word-break: break-word;">{{questions_type.question}}</span>
                                                        </div>
                                                    </div>
                                                    <div v-if="questions_type.question_type.value == 'Short Answer'" class="col-lg-12 col-md-12 col-sm-12 mt-3">
                                                        <span class="fs-14" style="color: #c4c4c4;">Short Answer</span>
                                                    </div>
                                                    <div v-if="questions_type.question_type.value == 'Paragraph'" class="col-lg-12 col-md-12 col-sm-12 mt-3">
                                                        <span class="fs-14" style="color: #c4c4c4;">Long Answer</span>
                                                    </div>
                                                    <div v-if="questions_type.question_type.value == 'Multiple Choice'" class="col-lg-12 col-md-12 col-sm-12 mt-3">
                                                        <div v-for="(mult_choice_opt, mult_choice_opt_index) in questions_type.options" :key="mult_choice_opt_index+'mult_choice_opt_index'">
                                                            <div class="d-flex form-check form-check-inline">
                                                                <label class="form-check-label w-100">
                                                                    <input class="form-check-input" :disabled="true" type="radio"
                                                                        value="option 1">
                                                                    <span style="top: -20px !important;" class="radio-icon"></span>
                                                                    <div class="inputFieldNew-border-bottom pb-0 w-100 fs-13" style="word-break: break-all;" >{{questions_type.options[mult_choice_opt_index]}}</div>
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div v-if="questions_type.question_type.value == 'Checkboxes'" class="col-lg-12 col-md-12 col-sm-12 mt-3">
                                                        <div v-for="(checkboxes_opt, checkboxes_opt_index) in questions_type.options" :key="checkboxes_opt_index+'checkboxes_opt_index'">
                                                            <div class="d-flex align-items-end">
                                                                <el-checkbox :disabled="true" class="mb-0 mr-2"></el-checkbox>
                                                                <div class="inputFieldNew-border-bottom pb-0 w-100 fs-13" style="word-break: break-all;" >{{questions_type.options[checkboxes_opt_index]}}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div v-if="questions_type.question_type.value == 'Dropdown'" class="col-lg-12 col-md-12 col-sm-12 mt-3">
                                                        <div v-for="(dropdown_opt, dropdown_opt_index) in questions_type.options" :key="dropdown_opt_index+'dropdown_opt_index'">
                                                            <div class="d-flex align-items-end">
                                                                <div class="inputFieldNew-border-bottom pb-0 w-100 fs-13" style="word-break: break-all;" >{{questions_type.options[dropdown_opt_index]}}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div v-if="questions_type.question_type.value == 'Star Ratings'" class="col-lg-12 col-md-12 col-sm-12 mt-3">
                                                        <div>
                                                            <i v-for="(i, index) in questions_type.number_of_stars" :key="index" class="icon icon-star" style="color: #ff9a06;font-size: 2.8rem;"></i>
                                                        </div>
                                                    </div>
                                                    <div v-if="questions_type.question_type.value == 'Multiple Choice Grids'" class="col-lg-6 col-md-6 col-sm-12">
                                                        <div v-for="(mult_choice_grid_row_opt, mult_choice_grid_row_opt_index) in questions_type.row_titles" :key="mult_choice_grid_row_opt_index+'mult_choice_grid_row_opt_index'" class="mt-3">
                                                            <div class="d-flex align-items-end">
                                                                <div class="inputFieldNew-border-bottom pb-0 w-100 fs-13" style="word-break: break-all;" >{{questions_type.row_titles[mult_choice_grid_row_opt_index]}}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div v-if="questions_type.question_type.value == 'Multiple Choice Grids'" class="col-lg-6 col-md-6 col-sm-12">
                                                        <div v-for="(mult_choice_grid_column_opt, mult_choice_grid_column_opt_index) in questions_type.column_titles" :key="mult_choice_grid_column_opt_index+'mult_choice_grid_column_opt_index'" class="mt-3">
                                                            <div class="d-flex form-check form-check-inline w-100">
                                                                <label class="form-check-label w-100">
                                                                    <input class="form-check-input" :disabled="true" type="radio"
                                                                        value="option 1">
                                                                    <span style="top: -22px !important;" class="radio-icon"></span>
                                                                    <div class="inputFieldNew-border-bottom pb-0 w-100 fs-13" style="word-break: break-all;" >{{questions_type.column_titles[mult_choice_grid_column_opt_index]}}</div>
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div v-if="questions_type.question_type.value == 'Checkboxes Grid'" class="col-lg-6 col-md-6 col-sm-12">
                                                        <div v-for="(checkboxes_grid_row, checkboxes_grid_row_index) in questions_type.row_titles" :key="checkboxes_grid_row_index+'checkboxes_grid_row_index'" class="mt-3">
                                                            <div class="d-flex align-items-end">
                                                                <div class="inputFieldNew-border-bottom pb-0 w-100 fs-13" style="word-break: break-all;" >{{questions_type.row_titles[checkboxes_grid_row_index]}}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div v-if="questions_type.question_type.value == 'Checkboxes Grid'" class="col-lg-6 col-md-6 col-sm-12">
                                                        <div v-for="(checkboxes_grid_column, checkboxes_grid_column_index) in questions_type.column_titles" :key="checkboxes_grid_column_index+'checkboxes_grid_column_index'" class="mt-3">
                                                            <div class="d-flex align-items-end">
                                                                <el-checkbox :disabled="true" class="mb-0 mr-2"></el-checkbox>
                                                                <div class="inputFieldNew-border-bottom pb-0 w-100 fs-13" style="word-break: break-all;" >{{questions_type.column_titles[checkboxes_grid_column_index]}}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div v-if="questions_type.question_type.value == 'Date'" class="col-lg-3 col-md-3 col-sm-6 mt-3">
                                                        <div class="d-flex align-items-center">
                                                            <date-picker name="date"
                                                                class="inputFieldNew-border-bottom date-picker-disabled" placeholder="MM/DD/YYYY"
                                                                format="MM/DD/YYYY" type="date" lang="en"
                                                                style="border:none !important" :disabled="true">
                                                            </date-picker>
                                                        </div>
                                                    </div>
                                                    <div v-if="questions_type.question_type.value == 'Time'" class="col-lg-3 col-md-3 col-sm-6 mt-3">
                                                        <date-picker
                                                            class="new-time-picker new-time-picker-icon input-field-underline date-picker-clock-icon mt-3"
                                                            placeholder="--:--" value-type="format" style="padding-right: 2px !important;" lang="en"
                                                            type="time" format="HH/MM" :disabled="true">
                                                        </date-picker>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row px-12">
                                        <div class="col-sm-12 col-md-12 col-lg-12 mt-5">
                                            <div v-if="loadAddQuestionModal == false" class="d-flex justify-content-end">
                                                <button class="btn text-white text-transform-none" @click="OpenAddQuestionModal()"
                                                    style="border-radius: 5px !important;background-color:#00448b;">+
                                                    Add Question</button>
                                            </div>
                                            <div v-else class="d-flex justify-content-end">
                                                <button class="btn text-white text-transform-none" style="position: relative; border-radius: 5px;" disabled>+ Add Question
                                                    <hollow-dots-spinner style="position: absolute;margin: 0;top: 22px;display: flex;justify-content: center;width: 100% !important;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
                                                </button>
                                            </div>
                                        </div>
                                        <div class="col-sm-12 col-md-12 col-lg-12 mt-8 mb-4">
                                            <div v-if="disableButtonAndDisplayLoader == false" class="d-flex justify-content-center">
                                                <button class="btn new-cancel-button mt-2" style="width: 120px !important;" @click="$router.go(-1)">Cancel</button>
                                                <button @click="saveAndView" class="btn new-save-button mt-2 ml-6" v-if="disable_save == false">Save and send</button>
                                            </div>
                                            <div v-else class="d-flex justify-content-center">
                                                <button class="btn btn-des-small mt-2 btn-cancel-style" style="border: 1px solid transparent !important;" disabled>Cancel</button>
                                                <button class="btn btn-des-small mt-2 ml-6 btn-new-save" style="position: relative;" disabled>Save and send
                                                    <hollow-dots-spinner style="position: absolute;margin: 0;top: 22px;display: flex;justify-content: center;width: 100% !important;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
        <!-- <success-message :message="'Survey Created successfully'" modal_name="success-message" @saveSuccess="saveSuccess"></success-message> -->
        <send-surveys-info @hide-send-survey-info="hideSendSurveyInfo" :form_id="form_id" modal_name="Send_Surveys_Info" v-if="send_surveys_info"></send-surveys-info>
        <add-question @hide-add-question-modal="hideAddQuestion" @saveQuestion="addNewQuestion" :selected_question="selected_question" modal_name="Show-Add-Question-Modal" v-if="add_question"></add-question>
    </div>
</template>

<script>
    import Swal from 'sweetalert2';
    const AddQuestion = () => import('./AddQuestion');
    const SendSurveysInfo = () =>  import('./SendSurveysInfo');
    import moment from 'moment';
    import { SweetModal } from 'sweet-modal-vue';
    import { HalfCircleSpinner } from "epic-spinners";
    import survey_forms from '../mixins/survey_forms';
    import productList from '../mixins/productList';
    import { HollowDotsSpinner } from "epic-spinners";
    const SuccessMessage = () => import("../SuccessMessage");
    import { debounce } from 'lodash';
    export default {
        mixins: [survey_forms, productList],
        components: {
            SendSurveysInfo,
            AddQuestion,
            SweetModal,
            HalfCircleSpinner,
            HollowDotsSpinner,
            AddQuestion,
            Swal,
            //SuccessMessage
        },
        data() {
            return {
                loadAddQuestionModal: false,
                disableButtonAndDisplayLoader: false,
                question_mode: 'new',
                selected_question_index: null,
                selected_question: [],
                add_question: false,
                send_surveys_info: false,
                ajax_call_in_progress: false,
                is_start_date: false,
                is_end_time:false,
                is_closure_date: false,
                success_msg: '',
                warning_msg: '',
                survey: {
                    survey_title: '',
                    industry_type: '',
                    survey_type: '',
                    product: '',
                    start_date: moment(new Date().toUTCString()).format("MM/DD/YYYY"),
                    closure_date: '',
                    start_time: moment(new Date().toUTCString()).format("LT"),
                    end_time: '',
                    form_description: '',
                    questions: [],
                },
                limit: 10,
                skip: 0,
                count_industry: 0,
                count_survey_type: 0,
                count_product_type: 0,
                isVisible: false,
                industry_visible:false,
                temp_dropdown_options: [],
                scrollable: false,
                industry_scrollable:false,
                search_key: "",
                industry_dropdown_loading: false,
                survey_dropdown_loading: false,
                product_dropdown_loading: false,
                industry_type_options: [],
                survey_type_options: [],
                product_options: [],
                form_id: '',
                disable_save: false,
                temp_data: [],
                selected_field:'',
                products_options:[],
                products_count: 0,
                products_loading: false,
                products_scrollable: false,
            }
        },
        methods: {
            limitProduct(count) {
                return `+ ${count} more`
            },
            resetData(type){
                this.selected_field = type
                this.products_options = [];
                this.products_count = 0;
            },
            async searchProuctNameDebouncer(search){
                this.products_loading = true
                this.products_count = 0
                let params = {
                    skip: this.skip,
                    limit: 10,
                    search_key: search,
                    sort_key: "name",
                    sort_value: 1,
                    category_ids:[],
                    sub_category_ids:[],
                    product_type_ids:[],
                    product_ids:[],
                    brand_ids:[],
                    outlet_ids:[],
                    status:[],  
                    visibility:"Manufacturing"
                }
                let response = await this.ProductsList(params)
                this.products_options = response.response.result
                
                this.products_count = this.products_options.length
                this.products_loading = false
            },
            async reachedEndOfProductName(reached){
                if(reached){
                    if(this.products_scrollable == false){
                        this.products_loading = true
                        let response = await this.ProductsList({
                            skip: this.products_count,
                            limit: 10,
                            search_key: '',
                            sort_key: "name",
                            sort_value: 1,
                            category_ids:[],
                            sub_category_ids:[],
                            product_type_ids:[],
                            product_ids:[],
                            brand_ids:[],
                            outlet_ids:[],
                            status:[],  
                            visibility:"Manufacturing"
                        } )
                        let temp_products_options = response.response.result.length;
                        if(response.response.filter_data.skip == this.products_count){
                            if(temp_products_options > 0){
                                let tempfiles = response.response.result
                                // tempfiles.forEach(el => {
                                //     if(el[this.selected_field] != '' && el.hasOwnProperty(this.selected_field)){
                                //         this.products_options.push(el)
                                //     }
                                // })
                                // let uniqueArray = this.products_options.filter((value, index_dd) => {
                                //     const _value = value[this.selected_field];
                                //     return index_dd === this.products_options.findIndex(obj => {
                                //         return obj[this.selected_field] === _value;
                                //     });
                                // });
                                this.products_options = tempfiles
                                this.products_count += response.response.result.length;
                                this.products_loading = false
                            } else {
                                this.products_scrollable = true
                                this.products_loading = false
                            }
                            this.products_scrollable = false
                        }
                    }
                }
            },
            editQuestion(question, index){
                this.question_mode = 'edit'
                this.selected_question = question
                this.selected_question_index = index
                this.add_question = true
                setTimeout(() => {
                    this.$modal.show('Show-Add-Question-Modal')
                }, 500)
            },
            limitIndustryType(count){
                return `+ ${count} more`
            },
            moment(date) {
                return moment(date);
            },
            timeInput(event, time, prevtime) {
            },
            async searchIndustryTypeDebouncer(value) {
                if(value == null ){
                    this.search_key = ""
                } else {
                    this.search_key = value
                }
                this.industry_dropdown_loading = true;
                let response = await this.getIndustryTypeDropdown({
                    limit: 10,
                    skip: 0,
                    type: 'industry_type',
                    search_key: this.search_key
                })
                this.industry_type_options = response.response
                this.count_industry = this.industry_type_options.length;
                this.industry_dropdown_loading = false;
                this.industry_scrollable = false
            },
            /*questionSelected(event, index) {
                // this.survey.questions[index].question_type.value = event.target.value;
            },*/
            async reachedEndOfIndustryType(reached) {
                this.industry_visible = reached;
                if (reached) {
                    if (this.industry_scrollable == false) {
                        this.industry_dropdown_loading = true;
                        let response = await this.getIndustryTypeDropdown({
                            skip: this.count_industry,
                            type: 'industry_type',
                            limit:10,
                            search_key:""
                        })

                        this.temp_dropdown_options = response.response.length;;
                        if (response.skip == this.count_industry) {
                            if (this.temp_dropdown_options > 0) {
                                let tempFiles = response.response;
                                tempFiles.forEach(el => {
                                    this.industry_type_options.push(el);
                                });
                                this.count_industry += response.response.length;
                                this.industry_dropdown_loading = false
                            } else {
                                this.industry_scrollable = true
                                this.industry_dropdown_loading = false
                            }
                        }
                        this.industry_dropdown_loading = false
                    }
                }
            },
            async searchSurveyTypeDebouncer(search) {
                this.survey_dropdown_loading = true;
                this.search_key = search;
                let params = {
                    limit: 10,
                    skip: 0,
                    search_key: this.search_key
                };
                let response = await this.getSurveyFormTypesDropdown(params);
                this.survey_type_options = response.response
                this.count_survey_type = response.response.length;
                this.survey_dropdown_loading = false;
            },
            async reachedEndOfSurveyType(reached) {
                this.isVisible = reached;
                if (reached) {
                    if (this.scrollable == false) {
                        this.survey_dropdown_loading = true;
                        let params = {
                            limit: 10,
                            skip: this.count_survey_type,
                            search_key: this.search_key
                        };
                        let response = await this.getSurveyFormTypesDropdown(params);
                        this.temp_dropdown_options = response.response.length;;
                        if (response.skip == this.count_survey_type) {
                            if (this.temp_dropdown_options > 0) {
                                let tempFiles = response.response;
                                tempFiles.forEach(el => {
                                    this.survey_type_options.push(el);
                                });
                                this.count_survey_type += response.response.length;
                                this.survey_dropdown_loading = false
                            } else {
                                this.scrollable = true
                                this.survey_dropdown_loading = false
                            }
                        }
                        this.survey_dropdown_loading = false
                    }
                }
            },
            async searchProductDebouncer(search) {
                this.product_dropdown_loading = true;
                this.search_key = search;
                let params = {
                    limit: 10,
                    skip: 0,
                    search_key: this.search_key,
                    sort_key: 'name',
                    sort_value: 1
                };
                let response = await this.getProductTypeDropdown(params);
                this.product_options = response.response
                this.count_product_type = response.response.length;
                this.product_dropdown_loading = false;
            },
            async reachedEndOfProductType(reached) {
                this.isVisible = reached;
                if (reached) {
                    if (this.scrollable == false) {
                        this.product_dropdown_loading = true;
                        let params = {
                            limit: 10,
                            skip: this.count_product_type,
                            search_key: this.search_key,
                            sort_key: 'name',
                            sort_value: 1
                        };
                        let response = await this.getProductTypeDropdown(params);
                        this.temp_dropdown_options = response.response.length;;
                        if (response.skip == this.count_product_type) {
                            if (this.temp_dropdown_options > 0) {
                                let tempFiles = response.response;
                                tempFiles.forEach(el => {
                                    this.product_options.push(el);
                                });
                                this.count_product_type += response.response.length;
                                this.product_dropdown_loading = false
                            } else {
                                this.scrollable = true
                                this.product_dropdown_loading = false
                            }
                        }
                        this.product_dropdown_loading = false
                    }
                }
            },
            // SendSurveysInfoModal(){
            //     this.send_surveys_info = true
            //     setTimeout(() =>{
            //         this.$modal.show("Send_Surveys_Info")
            //     },500)
            // },
            hideSendSurveyInfo(){
                this.send_surveys_info = false
                this.$router.push('/surveyform/listview');
            },
            addNewQuestion(data) {
                if(this.question_mode == 'new'){
                    this.survey.questions.push(data);
                } else if(this.question_mode == 'edit'){
                    this.survey.questions[this.selected_question_index].question = data.question;
                    this.survey.questions[this.selected_question_index].is_mandatory = data.is_mandatory;
                    this.survey.questions[this.selected_question_index].options = data.options;
                    this.survey.questions[this.selected_question_index].question_type = data.question_type;
                    this.survey.questions[this.selected_question_index].number_of_stars = data.number_of_stars;
                }
                this.add_question = false;
                this.selected_question_index = null;
                this.selected_question = []
                setTimeout(() => {
                    this.$modal.show('Show-Add-Question-Modal')
                }, 500)
            },
            saveAndView() {
                this.$validator.validateAll().then(result => {
                    if (result == true && this.survey.start_date && this.survey.closure_date && this.survey.end_time) {
                        this.is_start_date = false;
                        this.is_end_time =false;
                        this.is_closure_date = false;
                        this.create_data.questions.forEach((el, index) => {
                            if(el.hasOwnProperty('options')){
                                this.temp_data.push({
                                    is_mandatory: el.is_mandatory,
                                    question: el.question,
                                    options: el.options,
                                    question_type: el.question_type.id
                                })
                            } else if(el.hasOwnProperty('number_of_stars')){
                                this.temp_data.push({
                                    is_mandatory: el.is_mandatory,
                                    question: el.question,
                                    number_of_stars: el.number_of_stars,
                                    question_type: el.question_type.id
                                })
                            } else if(el.hasOwnProperty('row_titles' ) && el.hasOwnProperty('column_titles')){
                                this.temp_data.push({
                                    is_mandatory: el.is_mandatory,
                                    question: el.question,
                                    number_of_stars: el.number_of_stars,
                                    question_type: el.question_type.id,
                                    row_titles: el.row_titles,
                                    column_titles: el.column_titles
                                })
                            }
                            else{
                                this.temp_data.push({
                                    is_mandatory: el.is_mandatory,
                                    question: el.question,
                                    question_type: el.question_type.id
                                })
                            }
                            // el.question_type = el.question_type.id
                        });
                        this.create_data.questions = this.temp_data
                        this.saveSuccess();
                    } else {
                        if(this.survey.start_date == '' || this.survey.start_date == null || this.survey.start_date == undefined) {
                            this.is_start_date = true;
                        }
                        if(this.survey.closure_date == '' || this.survey.closure_date == null || this.survey.closure_date == undefined) {
                            this.is_closure_date = true;
                        }
                        if(this.survey.end_time == '' || this.survey.closure_date == null || this.survey.closure_date == undefined || (this.survey.end_time == '' && this.survey.closure_date != null)) {
                            this.is_end_time = true;
                        }
                        this.warning_msg = "Please Enter Mandatory Fields";
                        this.$refs.warning_modal.open();
                        setTimeout(() => {
                            this.$refs.warning_modal.close();
                        }, 2000);
                    }
                })
            },
            async saveSuccess() {
                this.disable_save = true;
                this.disableButtonAndDisplayLoader = true;
                try {
                    let response = await this.createSurveyForm(this.create_data);
                    this.form_id = response.form_id;
                    this.success_msg = response.message;
                    this.$refs.success_modal.open();
                    this.send_surveys_info = true
                    setTimeout(() => {
                        this.disable_save = false;
                        this.disableButtonAndDisplayLoader = false;
                        this.$refs.success_modal.close();
                        this.$modal.show("Send_Surveys_Info")
                    }, 2000);
                }
                catch (error) {
                    this.disable_save = false;
                    this.warning_msg = error;
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.disableButtonAndDisplayLoader = false;
                        this.$refs.warning_modal.close();
                    }, 2000);
                }
            },
            addNewEntry(index) {
                this.survey.questions.splice(index+1, 0, JSON.parse(JSON.stringify(this.survey.questions[index])));
            },
            deleteEntry(index) {
                this.survey.questions.splice(index, 1);
            },
            moveEntry(index, move_option) {
                if(move_option == 'move_up') {
                    let element = JSON.parse(JSON.stringify(this.survey.questions[index]));
                    this.survey.questions.splice(index, 1);
                    this.survey.questions.splice(index-1, 0, element);
                } else if(move_option == 'move_down') {
                    let element = JSON.parse(JSON.stringify(this.survey.questions[index]));
                    this.survey.questions.splice(index, 1);
                    this.survey.questions.splice(index+1, 0, element);
                }
            },
            OpenAddQuestionModal(){
                this.question_mode = 'new'
                this.loadAddQuestionModal = true;
                this.add_question = true
                setTimeout(() => {
                    this.$modal.show('Show-Add-Question-Modal')
                    this.loadAddQuestionModal = false;
                }, 1000)
            },
            hideAddQuestion(){
                this.add_question = false;
                //this.selected_question_index = null;
                this.selected_question = []
            }
        },
        mounted() {
        },
        computed: {
            searchProuctName(){
                return debounce(this.searchProuctNameDebouncer, 500)
            },
            current_date() {
                var date = new Date();
                date.setDate(date.getDate() + 1);
                return date;
            },
            create_data() {
                return {
                    title: this.survey.survey_title,
                    industry_type: this.survey.industry_type,
                    survey_type: this.survey.survey_type.id,
                    product: this.survey.product._id,
                    product_name: this.survey.product.name,
                    start_time: this.survey.start_time,
                    end_time: this.survey.end_time,
                    start_date: this.survey.start_date ? this.survey.start_date.split('/')[2]+'-'+this.survey.start_date.split('/')[0]+'-'+this.survey.start_date.split('/')[1] : '',
                    end_date: this.survey.closure_date ? this.survey.closure_date.split('/')[2]+'-'+this.survey.closure_date.split('/')[0]+'-'+this.survey.closure_date.split('/')[1] : '',
                    description: this.survey.form_description,
                    questions: this.survey.questions,
                }
            },
        },
        watch: {
            "survey.start_date": function(val) {
                if(val !== '') {
                    this.is_start_date = false;

                }
            },
            "survey.closure_date": function(val) {
                if(val !== '') {
                    this.is_closure_date = false;

                }
            },
            "survey.end_time": function(val) {
                if(val !== '') {
                    this.is_end_time = false;

                }
            }
        },
        created() {
            const dict = {
                custom: {
                    survey_title:{
                        required:() => "Survey Title is required"
                    },
                    industry_type:{
                        required:() => "Industry Type is required"
                    },
                   survey_type:{
                        required:() => "Survey Type is required"
                    },
                    // product:{
                    //     required:() => "Product is required"
                    // },
                    description:{
                        required:() => "Description is required"
                    },
                }
            }
            this.$validator.localize("en", dict);
            this.searchIndustryType = debounce(this.searchIndustryTypeDebouncer, 500)
            this.searchSurveyType = debounce(this.searchSurveyTypeDebouncer, 500)
            this.searchProduct = debounce(this.searchProductDebouncer, 500)
        }
    }
</script>

<style scoped>
    .input-field-underline {
        border: 0 !important;
        border-bottom: solid 0.5px #3f3f3f !important;
        background-color: #fff;
        padding: 0 !important;
        width: 100% !important;
        /* height: 40px; */
    }
    .decoration-none {
        text-decoration: none;
    }

    .text-transform-none {
        text-transform: none;
    }

    .survey-textarea {
        padding-top: 6px !important;
        width: 100%;
        background: transparent;
        color: #303031;
        border-radius: 5px;
        border: 0.6px solid #676767 !important;
        resize: none;
        height: 8em;
        padding: 10px;
        overflow-y: auto;
        padding-right: 75px !important;
    }

    .add-new-option {
        border-top: 1.5px solid #707070;
    }

    .preview-elements {
        background-color: #fff;
        padding: 28.5px 0 28.5px 0;
        border-radius: 6px;
    }

    .header-text-heading {
        padding: 9.7px 22.2px;
        background-color: #00448b;
    }

    .sub-heading {
        background-color: #00448b;
        width: 100%;
    } */

    .inputFieldNew-border-bottom {
        font-size: 14px !important;
        padding: 10px 11px 7px 8px !important;
        display: block;
        width: 100%;
        border: none;
        border-bottom: solid 1px #707070 !important;
        background: transparent !important;
        color: #303031;
        font-weight: 600;
        /* margin-top: 20px; */
    }

    .form-check-label input[type=radio]~.radio-icon:before,
    .form-check-label input[type=radio]~.radio-icon:after,
    .form-check-label input[type=radio]~.custom-control-indicator:before,
    .form-check-label input[type=radio]~.custom-control-indicator:after {
        border-color: #00448b;
    }

    .form-check-label input[type=radio]:checked~.radio-icon:before,
    .form-check-label input[type=radio]:checked~.custom-control-indicator:before {
        border-color: #00448b !important;
    }

    .form-check-label input[type=radio]:checked~.radio-icon:after,
    .form-check-label input[type=radio]:checked~.custom-control-indicator:after {
        background-color: #00448b !important;
    }

    .form-check-label input[type=radio]:checked~.radio-icon:before,
    .form-check-label input[type=radio]:checked~.custom-control-indicator:before {
        border-color: #00448b !important;
    }

    /* .form-check-label input {
        top: 13px
    } */
    .form-check-label input[type=radio]~.radio-icon:before{
        top: 25px !important;
    }
     .form-check-label input[type=radio]~.radio-icon:after{
         top: 25px !important;
     }
    .icon-right{
        color: #00448b !important;
    }
    .icon-tick-success{
        color:#008a63;
    }
    .mx-input-append {
        right: 3px !important;
    }
    .form-check-label input[type=radio], .custom-checkbox input[type=radio], .custom-radio input[type=radio] {
        top: 10px !important;
    }
    .form-check-input, .custom-control-input {
        width: 20px !important;
        height: 20px !important;
    }
    .btn-cancel-style {
        color: #d51650;
        background-color: #fff;
        border: 1px solid #d51650;
        width: 120px;
    }
    .btn-new-save {
        color: #fff;
        background-color: #008a63;
    }
    .new-date-picker .mx-input-append, .new-time-picker .mx-input-append, .date-picker-disabled .mx-input-append{
		background-image: url('/static/images/images-new-theme/icons/blue-calendar.svg') !important;
		background-repeat: no-repeat;
		background-size: contain;
		display: block !important;
		cursor: pointer;
		margin-top: 5px;
		width: 25px !important;
	}
    .text-line {
        text-decoration :none !important;
    }
    /* .hide-seconds .mx-datepicker-popup .mx-calendar .mx-calendar-content .mx-panel .mx-panel-time.mx-time-list:last-child{
        display:none !important
    } */
    .hide-seconds .mx-time-list:last-child{
        display:none !important
    }
    @media screen and (max-width: 575px) {
		.margin-res-575 {
            margin-top: 20px !important;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/SurveyForms/CreateSurveyForms.vue